module.exports = __webpack_public_path__ + "3be71172ac287b2118d00704a61d52ec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-converse-s.png
// module id = 2541
// module chunks = 0